import { handleResponse, SERVER_HOST } from "@api";
import { TProduct, TProductCategory } from "@components/types";
import { getLocation } from "@core/geolocation";
import axios from "axios";

export const getProducts = async (name: string = null) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/products/?${name == null ? "" : `name=${name}`}`)
    const products: TProduct[] = await res.json()
    return products;
}

export const getPopularProducts = async (pageNumber: number = 0, pageSize: number = 10) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/products/popular/?lat=0&lon=0&skip=${pageNumber * pageSize}&limit=${pageSize}`)
    const products: TProduct[] = await res.json()
    return products;
}

export const getHomegrownProducts = async () => {
    const response = await axios.get(`${SERVER_HOST}/api/v1/products/?homegrown=true`);
    return handleResponse(response);
}

export async function getTrendingProducts(
    categoryId: number = null,
    orderingOn: string = null,
    skip: number = 0,
    limit: number = 10,
) {
    const response = await axios.get(`${SERVER_HOST}/api/v1/products/trending/?${categoryId ? `category_id=${categoryId}&` : ''}${orderingOn ? `ordering_on=${orderingOn}&` : ''}skip=${skip}&limit=${limit}`);
    return handleResponse(response);
};

export async function getProductsByStoreId(
    store_id: number,
    categoryId: number = null,
    orderingOn: string = null,
    skip: number = 0,
    limit: number = 10,
) {
    const response = await axios.get(`${SERVER_HOST}/api/v1/products/?store_ids=${store_id}&${categoryId ? `category_id=${categoryId}&` : ''}${orderingOn ? `ordering_on=${orderingOn}&` : ''}skip=${skip}&limit=${limit}`);
    return handleResponse(response);
};

export async function getProductsByType(store_id: number, is_service: boolean = false) {
    if (store_id < 0) {
        const response = await axios.get(`${SERVER_HOST}/api/v1/products/?store_ids=${store_id}&is_service=${is_service}`);
        return handleResponse(response);
    }
};

export const getFeaturedProducts = async (category: number = null, store: number = null, brand: number = null, orderingOn: string = null, pageNumber: number = 0, pageSize: number = 10) => {
    let params = new URLSearchParams()
    if (category > 0) {
        params.append('category_id', category.toString());
    }
    if (store > 0) {
        params.append('store_id', store.toString());
    }
    if (brand > 0) {
        params.append('brand_id', brand.toString());
    }
    if (pageNumber !== null) {
        params.append('skip', (pageNumber * pageSize).toString());
    }
    if (pageSize !== null) {
        params.append('limit', pageSize.toString());
    }
    if (orderingOn?.length > 0) {
        params.append('ordering_on', orderingOn);
    }
    const res = await fetch(`${SERVER_HOST}/api/v1/products/popular/?${params.toString()}`)
    const products: TProduct[] = await res.json()
    return products;
}


export const getStoreProducts = async (category: number = null, store: number = null, name: string = null, pageNumber: number = 0, pageSize: number = 10) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/products/inventory?${category === null ? "" : `category_id=${category}&`}${store === null ? "" : `store_id=${store}&`}${name === null ? "" : `name=${name}`}&skip=${pageNumber * pageSize}&limit=${pageSize}`)
    const result = await res.json();
    // const storeProducts = result?.map((inventory: TInventory) => { let product = inventory.product; return { ...product, inventories: [inventory] } });
    const products: TProduct[] = result;
    return products;
}

export const getStoreInventory = async (category: number = null, store: number = null, name: string = null, pageNumber: number = 0, pageSize: number = 10) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/products/inventory/flat?${category === null ? "" : `category_id=${category}&`}${store === null ? "" : `store_id=${store}&`}${name === null ? "" : `name=${name}`}&skip=${pageNumber * pageSize}&limit=${pageSize}`)
    const result = await res.json();
    // const storeProducts = result?.map((inventory: TInventory) => { let product = inventory.product; return { ...product, inventories: [inventory] } });
    const products: TProduct[] = result;
    return products;
}


export const getDetailProduct = async (id: any) => {
    if (id > 0) {
        const res = await axios.get(`${SERVER_HOST}/api/v1/products/${id}`)
        const product: TProduct = handleResponse(res);
        return product;
    }
}

export const getSimilarProducts = async (id: number) => {
    let axiosMethod = axios.get;
    const res = await axiosMethod(`${SERVER_HOST}/api/v1/products/similar?product_id=${id}`)
    const products: TProduct[] = handleResponse(res);
    return products;
}


// `ordering_on` is one of the backend's popularity, bestseller, rating, published, relevence, frequent,
// trending, top, new. Without it the API returns the newest rows, which are individual stores' menu
// sections rather than the platform's main categories.
export const getProductCategories = async (master_id: number = null, root: boolean = false, limit: number = 10, ordering_on: string = null) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/productcategories/?root=${root}${master_id > 0 ? "&master_id=" + master_id.toString() : ""}${ordering_on ? "&ordering_on=" + ordering_on + "&ascending=false" : ""}&limit=${limit}`)
    const products: TProductCategory[] = await res.json()
    return products;
}


export const getStoreProductCategories = async (store_id: number = null, master_id: number = null, root: boolean = false, limit: number = 10) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/productcategories/?root=${root}${master_id > 0 ? "&master_id=" + master_id.toString() : ""}${store_id > 0 ? "&store_id=" + store_id.toString() : ""}&limit=${limit}`)
    const products: TProductCategory[] = await res.json()
    return products;
}


export const getProductCategory = async (category: number) => {
    if (category > 0) {
        const res = await fetch(`${SERVER_HOST}/api/v1/productcategories/${category}`)
        const products: TProductCategory = await res.json()
        return products;
    }
}

export const getAllProductCategory = async (orderingOn: string = "", pageNumber: number = 0, pageSize: number = 20) => {
    const res = await fetch(`${SERVER_HOST}/api/v1/productcategories/?${orderingOn?.length > 0 ? "ordering_on=" + orderingOn : ""}&root=false&skip=${pageNumber * pageSize}&limit=${pageSize}`)
    const products: TProductCategory[] = await res.json()
    return products;
}

export const getProductCategoriesList = async (id: number, pageNumber: number = 0, pageSize: number = 20) => {
    if (id > 0) {
        const res = await axios.get(`${SERVER_HOST}/api/v1/productcategories/?store_id=${id}&skip=${pageNumber * pageSize}&limit=${pageSize}`)
        const productCategoriesList = handleResponse(res);
        return productCategoriesList;
    }
}

export const getStoreProductCategoriesWithProducts = async (id: number, limit: number = 50) => {
    const res = await axios.get(`${SERVER_HOST}/api/v1/productcategories/store?store_id=${id}&limit=${limit}`)
    const productCategoriesList = handleResponse(res);
    return productCategoriesList;
}

export const getStoreProductCategoriesWithProductsList = async (id: number, limit: number = 50) => {
    const res = await axios.get(`${SERVER_HOST}/api/v1/productcategories/store/v3?store_id=${id}&limit=${limit}`)
    const productCategoriesList = handleResponse(res);
    return productCategoriesList;
}

export const getStoreProductCategoriesWithProductsListV5 = async (id: number, limit: number = 50) => {
    const res = await axios.get(`${SERVER_HOST}/api/v1/productcategories/store/v5?store_id=${id}&limit=${limit}`)
    const productCategoriesList = handleResponse(res);
    return productCategoriesList;
}

// `nearby` limits results to sellers around the visitor's location. A product whose only sellers are
// far away comes back empty in that mode, so callers can retry with nearby=false.
export const getAllStoresProducts = async (name: string = null, category_id: number = null, pageNumber: number = 0, pageSize: number = 20, nearby: boolean = true) => {
    const location = nearby ? await getLocation() : null;
    const params = new URLSearchParams();
    if (name != null && name !== "") params.set("name", name);
    if (category_id > 0) params.set("category_id", String(category_id));
    params.set("skip", String(pageNumber * pageSize));
    params.set("limit", String(pageSize));
    if (location?.latitude !== null && location?.latitude !== undefined) params.set("lat", String(location.latitude));
    if (location?.longitude !== null && location?.longitude !== undefined) params.set("lon", String(location.longitude));
    const res = await fetch(`${SERVER_HOST}/api/v1/products/inventory/search?${params.toString()}`)
    const products: TProduct[] = await res.json()
    return Array.isArray(products) ? products : [];
}

